/**
 * REGISTRY — maps every CSS selector to its feature file.
 *
 * Add one line when adding a new feature. That's it.
 *
 * Format:
 *   'CSS selector': 'relative path to the feature file'
 *
 * The path is relative to this file (src/core/).
 * At build time a Rollup plugin converts each path string into a
 * dynamic import function — you never write that yourself.
 */
export const REGISTRY = {
  '[data-bolk-anim="fadein"]':   '../features/anim/fadein.js',
  '[data-bolk-anim="stagger"]':  '../features/anim/stagger.js',
  '[data-bolk-anim="reveal"]':   '../features/anim/reveal.js',
  '[data-bolk-anim="counter"]':  '../features/anim/counter.js',
  '[data-bolk-anim="marquee"]':  '../features/anim/marquee.js',
  '[data-bolk-anim="parallax"]': '../features/anim/parallax.js',
  '[data-bolk-anim="magnetic"]': '../features/anim/magnetic.js',
  '[data-bolk-anim="tilt"]':     '../features/anim/tilt.js',
  '.splide':                      '../features/ui/slider.js',
  '[data-bolk-accordion="group"]':    '../features/ui/accordion.js',
};
